"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteFileSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class RequestForQuoteFileSearchResponse extends common_1.PaginatedResponse {
}
exports.RequestForQuoteFileSearchResponse = RequestForQuoteFileSearchResponse;
//# sourceMappingURL=request-for-quote-file-search.response.js.map